/**
 * Arrow-up on an empty composer recalls the last prompt (ADMIN-212), like a shell: in a chat, the
 * last message you sent in it; on a new chat, the last question you asked anywhere in this
 * workspace (the home's recent history).
 */

type RecallMessage = {
  readonly role: string;
  readonly content: readonly { readonly type: string; readonly text?: string }[];
};

type RecallHistoryEntry = { readonly type: string; readonly query: string };

export function lastPrompt(
  messages: readonly RecallMessage[],
  history: readonly RecallHistoryEntry[] = [],
): string | undefined {
  for (let i = messages.length - 1; i >= 0; i--) {
    const message = messages[i];
    if (message?.role !== "user") continue;
    const text = message.content
      .filter((p) => p.type === "text" && typeof p.text === "string")
      .map((p) => p.text)
      .join("\n\n")
      .trim();
    if (text) return text;
  }
  if (messages.length > 0) return undefined;
  return history.find((e) => e.type === "ai" && e.query.trim())?.query;
}

/** Only a bare ArrowUp on an empty composer recalls; anywhere else it moves the caret. */
export function shouldRecall(
  e: Pick<KeyboardEvent, "key" | "shiftKey" | "altKey" | "ctrlKey" | "metaKey" | "isComposing">,
  composerText: string,
): boolean {
  return (
    e.key === "ArrowUp" &&
    !e.shiftKey &&
    !e.altKey &&
    !e.ctrlKey &&
    !e.metaKey &&
    !e.isComposing &&
    composerText === ""
  );
}
